class CollectionProductsCarousel extends HTMLElement {
  constructor() {
    super();

    // COMPONENT STATE
    this.collectionProductTemplate = `
      <collection-product-card data-handle="{{ product.handle }}" class="product-container group w-[285px] lg:w-[338px] xl:w-[420px] 2xl:w-[548px] h-max">
        <figure id="product-images-container" class="h-[375px] xl:h-[600px] 2xl:h-[688px] w-full relative cursor-pointer">
          <a class="block absolute inset-0" href="{{ product.url }} "></a>
          <div class="w-full h-full">
            <img featured-image data-lazy src="{{ product.images.[0] }}" alt="{{ product.title }}" class="h-full w-full object-cover object-center">
            <div class="absolute flex flex-col gap-1 w-full h-min inset-0 p-[10px]">
              {{dynamicTags @root.product}}
            </div>
          </div> 
        </figure>
        <div class="product-quick-buy-container hidden lg:block invisible bg-black px-5 absolute bottom-0 w-full">
          <div class="quick-buy-size flex items-center border-b border-[#818181] py-5">
            <h3 class="text-white font-light  text-sm mr-4">Size:</h3>
            <div id="size-variants-container" class="flex flex-wrap gap-2">
              {{#each product.options.[0].values as |variant| }}
                <button variant-size-option class="size-variant  w-20 h-max py-1 text-white border border-gray-500 font-light text-sm">{{ variant }}</button>
              {{/each}}
            </div>
          </div>
          <div class="quick-buy-color flex items-center justify-between border-b border-[#818181] py-5">
            <div class="flex items-center">
              <h3 class="text-white font-light  text-sm mr-4">Color:</h3>
              <div id="color-variants-container" class="flex flex-wrap gap-2">
                <div variant-color-option default-variant-color-option data-handle="{{ product.handle }}" class="product-color-variant active cursor-pointer h-6 w-6 rounded-full overflow-hidden">
                  <img data-lazy src="{{ product.images.[0] }}" alt="{{ product.title }}" class="h-full w-full object-cover scale-[5] object-center">
                </div>
              </div>
            </div>
          </div>
          <div class="quick-buy-action border-b border-[#818181] py-5">
            <div class="flex items-start justify-between">
              <a href="{{ product.url }}" class="text-white font-light  text-sm mr-4">{{ product.title }}</a>
                <button id="quick-buy-add" class="flex items-center text-sm text-white whitespace-nowrap tracking-tighter font-light cursor-pointer"><span class="text-xl mr-2 leading-none">+</span><span id="add-to-cart-text">Add to Cart</span></button>
                <div class='klaviyo-product-container klaviyo-product-container-quick-add hidden !opacity-100' id='klaviyo-data-handle-{{ product.handle }}' data-klaviyo-handle='{{ product.handle }}'>
                  <div style="position: static !important;" class="klaviyo-button-container !flex !top-0 !ml-0 !left-0 !w-min !static !opacity-100">
                  </div>
                </div>
            </div>
            <div class="flex items-center justify-between gap-2">
              <span class="text-white font-light  text-sm mr-4">{{ product.price }}</span>
            </div>
          </div>
        </div>
        <div class="product-info-container mt-3 md:pr-4 pl-4">
          <div class="product-title-container h-7 flex items-start justify-between">
            <a href="{{ product.link }}" class="text-sm hover:underline cursor-pointer leading-4 tracking-tighter  font-normal">{{ product.title }}</a>
          </div>
          <div id="product-price" class="product-price-container flex items-center justify-between gap-2">
            {{#if (isnotzero quantity_total) }}
              {{#if product.is_discounted}}
                <div class="flex items-center gap-2">
                  <s class="text-sm font-normal text-gray-500">{{ product.original_price_formatted }}</s>
                  <span class="text-sm font-normal">{{ product.price }}</span>
                </div>
              {{else}}
                <span class="text-sm font-normal">{{ product.price }}</span>
              {{/if}}
            {{/if}}
            {{#unless (isnotzero quantity_total) }}
              <span class="text-sm font-normal  text-[#587311]">Sold Out</span>
              <div class='klaviyo-product-container klaviyo-product-container-quick-add !opacity-100' id='klaviyo-data-handle-{{ product.handle }}' data-klaviyo-handle='{{ product.handle }}'>
                <div style="position: static !important;" class="klaviyo-button-container !flex !top-0 !ml-0 !left-0 !w-min !static !opacity-100">
                  <a class="klaviyo-bis-trigger" href="#" style="padding: inherit;" data-klaviyo-handle="{{ product.handle }}">Notify Me</a>
                </div>
              </div>
            {{/unless}}
          </div>
        </div>
      </collection-product-card>
    `;

    // COMPONENT ELEMENTS
    this.collectionProductsContainer = this.querySelector(
      "#collection-products-container"
    );
    this.collectionProductsSlider = null;
    this.productContainers = this.querySelectorAll(".product-container");
    this.productId = this.getAttribute("data-product-id");
    this.productSrc = this.getAttribute("data-product-src");
    this.productManualDiscountEnabled = this.getAttribute("data-manual-discount-enabled");
    this.productManualDiscountPercentage = this.getAttribute("data-manual-discount-percentage");
    this.productManualDiscountCollections = (this.getAttribute("data-manual-discount-collections") || "")
      .split(",").map(h => h.trim()).filter(Boolean);
    this.discountProductIds = new Map(); // productId -> discount percentage

    // BINDINGS | EVENT LISTENERS
    this.bindEvents();

    const init = () => {
      if (this.productSrc === "collection" || this.productSrc === "product-collection") {
        this.initializeProductsCarousel();
      } else {
        this.initializeRecommendedProducts();
      }
    };

    const globalPct = parseFloat(this.productManualDiscountPercentage) || 50;
    const rules = this.productManualDiscountCollections.map(r => {
      const [handle, pct] = r.split(":").map(s => s.trim());
      return { handle, percentage: parseFloat(pct) || globalPct };
    });

    if (this.productManualDiscountEnabled === "true" && rules.length > 0) {
      Promise.all(
        rules.map(({ handle, percentage }) =>
          fetch(`/collections/${handle}/products.json?limit=250`)
            .then(r => r.json())
            .then(({ products }) =>
              products.forEach(p => {
                if (!this.discountProductIds.has(p.id)) {
                  this.discountProductIds.set(p.id, percentage);
                }
              })
            )
            .catch(() => {})
        )
      ).then(init);
    } else {
      init();
    }
  }

  bindEvents() {
    document.addEventListener("beforeCollectionChanged", (event) => {
      if (this.collectionProductsSlider)
        this.collectionProductsSlider.destroy();
    });
    document.addEventListener("collectionChanged", (event) => {
      this.initializeProductsCarousel();
    });
  }

  initializeRecommendedProducts() {
    if (
      this.productSrc === "collection" ||
      this.productSrc === "product-collection"
    )
      return;
    fetch(
      window.Shopify.routes.root +
        `recommendations/products.json?product_id=${this.productId}&limit=6&intent=related`
    )
      .then((response) => response.json())
      .then(({ products }) => {
        this.collectionProductsContainer.innerHTML = "";
        products.forEach((product, index) => {
          if (
            product.handle == "routeins" ||
            product.handle.includes("embroidery") ||
            product.featured_image == null ||
            product.tags.includes("PRIVATE") ||
            product.tags.includes("cart-only")
          ) {
            products.splice(index, 1);
          }
        });
        products.forEach((product, index) => {
          product.price = window.Shopify.formatMoney(product.price);
          this.collectionProductsContainer.insertAdjacentHTML(
            "beforeend",
            this.renderProduct(product)
          );
          if (index === products.length - 1) {
            setTimeout(() => {
              this.initializeProductsCarousel();
            }, 100);
          }
        });
      });
  }

  renderProduct(product) {
    // let productTags = product.tags.replaceAll('[:ATTR:]', ',').split(',');
    let productTags = product.tags;
    let materialTags = productTags.filter((tag) => tag.includes("material_"));
    let materialLabel = "";
    materialTags = materialTags.map((tag) => tag.replace("material_", ""));
    if (materialTags.length > 2) {
      materialTags.forEach((tag, index) => {
        if (index === 0) {
          materialLabel += tag;
        } else if (index === materialTags.length - 1) {
          materialLabel += ` & ${tag}`;
        } else {
          materialLabel += `, ${tag}`;
        }
      });
    } else {
      materialLabel = materialTags.join(" & ");
    }
    product.materials = materialLabel;

    const isAvailable = product.variants?.some(v => v.available);
    const rawPriceCents = product.variants?.[0]?.price || 0;

    const discountPercentage = this.discountProductIds.get(product.id);
    const isInDiscountCollection = discountPercentage !== undefined;

    if (this.productManualDiscountEnabled === "true" && isInDiscountCollection && isAvailable && rawPriceCents > 0) {
      const discountRate = discountPercentage / 100;
      const discountedCents = Math.round(rawPriceCents * (1 - discountRate));
  
      product.original_price_formatted = window.Shopify.formatMoney(rawPriceCents) + ' ' + window.Shopify.currency.active;
      product.price = window.Shopify.formatMoney(discountedCents);
      product.is_discounted = true;
    } else {
      product.price = window.Shopify.formatMoney(rawPriceCents, '{{amount_no_decimals}}') + ' ' + window.Shopify.currency.active;
      product.is_discounted = false;
    }

    console.log('product object', product);

    let templateSpec = Handlebars.compile(this.collectionProductTemplate);
    let template = templateSpec({ product: product });

    return template;
  }

  initializeProductsCarousel() {
    this.collectionProductsSlider = new Flickity(
      this.collectionProductsContainer,
      {
        // options
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        contain: true,
        lazyLoad: 3,
      }
    );
  }

  calculateDiscountedPrice(priceCents) {
    if (this.productManualDiscountEnabled && priceCents) {
      const discountPercentage = parseFloat(this.productManualDiscountPercentage) / 100;
      const discountedCents = Math.round(priceCents * (1 - discountPercentage));
      return window.Shopify.formatMoney(discountedCents); // returns e.g. "$96.00"
    }
    return window.Shopify.formatMoney(priceCents || 0);
  }
}

customElements.define(
  "collection-products-carousel",
  CollectionProductsCarousel
);

class CollectionSelector extends HTMLElement {
  constructor() {
    super();

    // COMPONENT STATE
    this._selectedCollection = null;

    // COMPONENT ELEMENTS
    this.collectionSelector = this.querySelector("#collection-selector");
    this.collectionOptions = this.querySelectorAll("[collection-option]");
    this.collectionProductsContainer = this.closest(
      "collection-products-carousel"
    ).querySelector("#collection-products-container");
    this.productTemplate = this.closest(
      "collection-products-carousel"
    ).querySelector("#product-template").innerHTML;
    this.productSkeleton = `
      <div class="product-container animate-pulse group w-[285px] lg:w-[588px] h-max mr-4">
        <figure id="product-images-container" class="h-[375px] rounded-sm bg-gray-300 lg:h-[41.67vw] w-full relative">
        </figure>
        <div class="product-info-container mt-4 hidden">
          <div class="h-4 w-1/2 bg-gray-300 rounded-sm"></div>
          <div class="h-4 w-1/4 bg-gray-300 rounded-sm mt-2"></div>
        </div> 
      </div>
    `;

    // BINDINGS | EVENT LISTENERS
    this.bindEvents();
  }

  bindEvents() {
    this.collectionOptions.forEach((option) => {
      option.addEventListener("click", this.handleCollectionChange.bind(this));
    });
  }

  deselectAllCollections() {
    this._selectedCollection = null;
    this.collectionOptions.forEach((option) => {
      option.classList.remove("active");
    });
  }

  handleCollectionChange(e) {
    if (e.target.closest("[collection-option]").classList.contains("active"))
      return;
    let beforeCollectionChanged = new CustomEvent("beforeCollectionChanged");
    document.dispatchEvent(beforeCollectionChanged);
    this.collectionOptions.forEach((option) => {
      option.setAttributeNS(null, "disabled", "true");
      option.classList.add("cursor-not-allowed");
    });
    let optionElement = e.target.closest("[collection-option]");
    let collectionHandle = optionElement.dataset.collectionHandle;
    let collectionId = optionElement.dataset.collectionId;

    if (optionElement.classList.contains("active")) {
      this.collectionOptions.forEach((option) => {
        option.disabled = false;
        option.classList.remove("cursor-not-allowed");
      });
      return;
    }
    this.deselectAllCollections();
    this._selectedCollection = collectionId;
    optionElement.classList.add("active");

    while (this.collectionProductsContainer.firstChild) {
      this.collectionProductsContainer.removeChild(
        this.collectionProductsContainer.firstChild
      );
    }

    this.collectionProductsContainer.insertAdjacentHTML(
      "beforeend",
      this.productSkeleton
    );

    fetch(`/collections/${collectionHandle}/products.json`)
      .then((response) => response.json())
      .then((data) => {
        this.collectionProductsContainer.innerHTML = "";
        data.products.forEach((product) => {
          // let productTags = product.tags.replaceAll('[:ATTR:]', ',').split(',');
          let productTags = product.tags;
          let materialTags = productTags.filter((tag) =>
            tag.includes("material_")
          );
          let materialLabel = "";
          materialTags = materialTags.map((tag) =>
            tag.replace("material_", "")
          );
          if (materialTags.length > 2) {
            materialTags.forEach((tag, index) => {
              if (index === 0) {
                materialLabel += tag;
              } else if (index === materialTags.length - 1) {
                materialLabel += ` & ${tag}`;
              } else {
                materialLabel += `, ${tag}`;
              }
            });
          } else {
            materialLabel = materialTags.join(" & ");
          }
          product.materials = materialLabel;
          // Format the price above to USD using the locale, style, and currency.
          let price = Shopify.formatMoney(
            product.variants[0].price,
            '{{amount_no_decimals}}'
          );
          product.price = `${price}`;
          let template1Func = Handlebars.compile(this.productTemplate);
          let compiledTemplate = template1Func({ product: product });
          this.collectionProductsContainer.insertAdjacentHTML(
            "beforeend",
            compiledTemplate
          );
        });
      })
      .then(() => {
        this.collectionOptions.forEach((option) => {
          option.disabled = false;
          option.classList.remove("cursor-not-allowed");
        });
        let event = new CustomEvent("collectionChanged", {
          detail: { collectionId: collectionId },
        });
        document.dispatchEvent(event);
      });
  }
}

customElements.define("collection-selector", CollectionSelector);

class CollectionGridCarousel extends HTMLElement {
  constructor() {
    super();

    // COMPONENT STATE

    // COMPONENT ELEMENTS
    this.collectionProductsContainer = this.querySelector(
      "#collection-products-container"
    );
    this.collectionProductsSlider = null;
    this.productContainers = this.querySelectorAll(".product-container");

    // BINDINGS | EVENT LISTENERS
    this.bindEvents();
    this.initializeProductsCarousel();
  }

  bindEvents() {
    document.addEventListener("beforeCollectionChanged", (event) => {
      if (this.collectionProductsSlider)
        this.collectionProductsSlider.destroy();
    });
    document.addEventListener("collectionChanged", (event) => {
      this.initializeProductsCarousel();
    });
  }

  initializeProductsCarousel() {
    // if (window.innerWidth > 1024) return;
    let splide = new Splide(this, {
      type: "loop",
      autoScroll: {
        speed: 2,
        autoStart: true,
      },
      live: false,
      perPage: 1,
      dragMinThreshold: 0,
      gap: "1rem",
      pauseOnHover: false,
      autoWidth: true,
      pagination: false,
      arrows: false,
      breakpoints: {
        1024: {
          autoScroll: {
            speed: 1,
            pauseOnHover: false,
          },
        },
      },
    });
    let AutoScroll = window.splide.Extensions.AutoScroll;
    splide.mount({ AutoScroll });
  }
}

customElements.define("collection-grid-carousel", CollectionGridCarousel);
